export const PAGE_GAP = "gap";

// Padrão de todas as tabelas do sistema; 100 é o teto porque é o limite que
// /projects valida no servidor.
export const DEFAULT_PAGE_SIZE = 10;

export function totalPagesOf(total, pageSize) {
  if (!total || !pageSize) return 0;
  return Math.ceil(total / pageSize);
}

export function visibleRange({ page, pageSize, total }) {
  if (!total) return { from: 0, to: 0 };
  const from = (page - 1) * pageSize + 1;
  return { from, to: Math.min(page * pageSize, total) };
}

// Primeira página, três em volta da atual, última — com PAGE_GAP onde a
// sequência salta. Janela fixa de três para o controle não mudar de largura
// ao navegar.
export function pageWindow(page, totalPages) {
  if (totalPages < 1) return [];

  const start = Math.max(1, Math.min(page - 1, totalPages - 2));
  const end = Math.min(totalPages, start + 2);

  const pages = [1];
  for (let candidate = start; candidate <= end; candidate += 1) {
    if (candidate > 1) pages.push(candidate);
  }
  if (totalPages > 1 && pages[pages.length - 1] !== totalPages) pages.push(totalPages);

  return pages.flatMap((current, index) =>
    index > 0 && current - pages[index - 1] > 1 ? [PAGE_GAP, current] : [current]
  );
}
